import React, {useEffect} from "react";
//import Helmet from "react-helmet"
import Header from "./header";
import Footer from "./footer"
import {useSelector,useDispatch} from "react-redux"
import {gethistory} from '../state/action'
import { useParams } from "react-router-dom";
function History(){
  let params = useParams();
 let countryId = params.id;
  
  const  history  = useSelector((state) =>  state.gemstone.history);
  const dispatch = useDispatch();
let detail= history.filter(state => state.id==countryId)
console.log(detail)
  useEffect(() => {
    dispatch(gethistory(countryId));
  }, []);
    return (
      <div>
      <Header/>
      {detail.map((i)=>{
       return (
     <section classname="page-title centred" style={{backgroundImage: 'url('+i.image+')' ,  backgroundPosition: 'center',
     backgroundSize: 'cover',
     backgroundRepeat: 'no-repeat',
     width: '100vw',
     height: '90vh'}}>
 
</section>

       )
      })}
 

<section className="project-details">
  <div className="auto-container">
    <div className="project-details-content">
    
      <div className="text">
        <h2>{detail[0]?.title} </h2>
        <p>{detail[0]?.description}</p>
      
       
      </div>
      {detail[0]?.type.map((i)=>{
         return(
           
          <div className="two-column">
          <div className="row align-items-center clearfix">
            <div className="col-lg-5 col-md-6 col-sm-12 image-column">
              <figure className="image"><img style={{width:"250px",height:"150px"}} src={i.image} alt />
              <br></br>
              </figure>
            </div>
            <div className="col-lg-7 col-md-6 col-sm-12 text-column">
              <p><span style={{"font-weight":"bold","font-size":"20px","font_color":"black"}}>{i.name}</span> <br></br>{i.description}</p>
            </div>
          </div>
        </div>
         )
       })}
    
    </div>
  </div>
</section>


<Footer/>
  </div>
    )
}
export default History;